import React from "react";
import {deconstructPackageUID, getPackageUID, PACKAGE_STATES} from "../../../../lib/WarehouseHelper";
import {updatePackages} from "../../../../actions/WarehousePackageActions";
import {useDispatch} from "react-redux";
import {graphql} from "react-apollo";
import {compose} from "redux";
import {CANCEL_PACKED, MARK_LOADED} from "../../../../queries/warehouseJobs";
import ActionButton from "../../../../components/ActionButton";
import {simpleDateFormat} from "../../../../lib/DateFormatter";
import {connect} from "react-redux";
import {showContextualMenu} from "../../../../actions/ViewActions";
import ContextMenuTrigger from "../../../../components/ContextMenuTrigger";
import styles from "./PackageActions.module.scss";


// In packed state, the user can select packages and mark them as loaded
// or take either a job or a package and set them back to packing.
const PackedActions = (props) => {
  const { jobId, packageUIds } = props;

  if (packageUIds) {
    return <ActionsForBatchLoading {...props} />;
  } else if (jobId) {
    return <ActionsForSingleJob {...props} />;
  } else {
    return <ActionsForSinglePackage {...props} />;
  }
}

// When user selects any number of packages and wants to mark all as loaded
function ActionsForBatchLoading(props) {
  const { warehouseId, packageUIds, afterClick } = props;

  const dispatch = useDispatch();

  const handleLoaded = () => {
    // Update those packages states
    dispatch(updatePackages(warehouseId, packageUIds, (p) => p.set("state", PACKAGE_STATES.IN_TRANSIT )));
    // Send mutation to server
    let currentJobId = null;
    const jobIdAndPackageIds = packageUIds.reduce((acc, uid) => {
      const { jobId, packageId } = deconstructPackageUID(uid);
      // Here, assuming job ids are listed one after the other and not random
      if (jobId !== currentJobId) {
        currentJobId = jobId;
        acc.push({
          jobId: jobId,
          packageIds: [],
        })
      }

      acc[acc.length - 1].packageIds.push(packageId);

      return acc;
    }, []);
    props.markLoaded(warehouseId, jobIdAndPackageIds, simpleDateFormat(new Date()));

    if (afterClick) {
      afterClick();
    }
  }

  return (
    <ActionButton
      onClick={handleLoaded}
      active={packageUIds.size > 0}
      label="Mark as Picked Up"
    />
  );
}

// Either load or revert to packing
function ActionsForSingleJob(props) {
  const { warehouseId, jobId, packages } = props;

  const dispatch = useDispatch();

  const handleLoaded = () => {
    const jobPackages = packages.filter((p) => p.get("jobId") === jobId);

    // Update those packages states
    dispatch(updatePackages(warehouseId, jobPackages.map((p) => getPackageUID(p)), (p) => p.set("state", PACKAGE_STATES.IN_TRANSIT)));
    // Send mutation to server
    const jobIdAndPackageIds = [
      { jobId: jobId, packageIds: jobPackages.map((p) => p.get("packageId")) }
    ];
    props.markLoaded(warehouseId, jobIdAndPackageIds, simpleDateFormat(new Date()));
  }

  const handleJobRevert = () => {
    // Update packages in the reducer
    dispatch(updatePackages(warehouseId, packages.map((p) => getPackageUID(p)), (p) => p.set("state", PACKAGE_STATES.PACK)));
    // Send mutation to server
    return props.cancelPacked(warehouseId, jobId, packages.map((p) => p.get("packageId")));
  }

  const onContextClick = (x, y) => {
    let items = [
      {label: "Mark All as Picked Up", lambda: handleLoaded },
      {label: "Cancel packed", lambda: handleJobRevert },
    ];

    props.showContextualMenu(items, x, y);
  }
  
  return (
    <div className={styles.headerActions}>
      <ContextMenuTrigger active={props.active} onClick={onContextClick}/>
    </div>
  );
}


// Either load or revert to packing
function ActionsForSinglePackage(props) {
  const { warehouseId, pack, detailView } = props;

  const dispatch = useDispatch();

  const handleLoaded = () => {
    // Update those packages states
    dispatch(updatePackages(warehouseId, getPackageUID(pack), (p) => p.set("state", PACKAGE_STATES.IN_TRANSIT)));
    // Send mutation to server
    const jobIdAndPackageIds = [
      { jobId: pack.get("jobId"), packageIds: [pack.get("packageId")] }
    ];
    props.markLoaded(warehouseId, jobIdAndPackageIds, simpleDateFormat(new Date()));
  }

  const handlePackageRevert = () => {
    // Update packages in the reducer
    dispatch(updatePackages(warehouseId, getPackageUID(pack), (p) => p.set("state", PACKAGE_STATES.PACK)));
    // Send mutation to server
    return props.cancelPacked(warehouseId, pack.get("jobId"), [pack.get("packageId")]);
  }

  const onContextClick = (x, y) => {
    let items = [
      {label: "Mark as Picked Up", lambda: handleLoaded },
      {label: "Cancel Packed", lambda: handlePackageRevert },
    ];

    props.showContextualMenu(items, x, y);
  }

  return (
    <div className={styles.headerActions}>
      { detailView && <ActionButton active={props.active} onClick={handleLoaded} label="Mark as Picked Up"/> }
      <ContextMenuTrigger active={props.active} onClick={onContextClick}/>
    </div>
  );
}


const withQuery = compose(
  graphql(MARK_LOADED, {
    props: ({ mutate }) => ({
      markLoaded: (warehouseId, jobs, loadDate) => mutate({
        variables: { data: { warehouseId, jobs, loadDate } }
      })
    })
  }),
  graphql(CANCEL_PACKED, {
    props: ({ mutate }) => ({
      cancelPacked: (warehouseId, jobId, packageIds) => mutate({
        variables: { data: { warehouseId, jobId, packageIds } }
      })
    })
  }),
);

export default connect(null, {showContextualMenu})(withQuery(PackedActions));